import { render, staticRenderFns } from "./OwnList.vue?vue&type=template&id=54499562&scoped=true"
import script from "./OwnList.vue?vue&type=script&lang=js"
export * from "./OwnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54499562",
  null
  
)

export default component.exports